/**
 * The register detail page's card shell and its date formatter.
 *
 * Extracted so a card can live in its own file without importing the page that
 * renders it, which would be a cycle.
 */
import type { LucideIcon } from "lucide-react";

/** ISO date to "12.08.2026"; missing dates read as a dash, never as "Invalid Date". */
export function fmtDate(s: string | null | undefined): string {
  if (!s) return "-";
  const d = new Date(s);
  if (Number.isNaN(d.getTime())) return "-";
  return d.toLocaleDateString("et-EE");
}

export function Card({
  title,
  icon: Icon,
  aside,
  children,
}: {
  title: string;
  icon: LucideIcon;
  /** Optional right-hand slot in the header - a count, a toggle. */
  aside?: React.ReactNode;
  children: React.ReactNode;
}) {
  return (
    <section className="rounded-xl border border-border bg-card/80 p-5 shadow-soft backdrop-blur">
      <h2 className="mb-4 flex items-center gap-2 text-sm font-semibold">
        <Icon className="size-4 text-primary" /> {title}
        {aside ? <span className="ml-auto font-normal">{aside}</span> : null}
      </h2>
      {children}
    </section>
  );
}
